import logo from "../SVGs/logo.svg"
import i1 from "./Logo2.png";
import i2 from "./Logo3.png";
import i3 from "./Logo4.png";
import i4 from "./Logo7.png";
import i5 from "./Logo6.png";
import i6 from "./Logo7.png";
import i7 from "./Logo6.png";
import i8 from "./Logo10.png";
import i9 from "./Logo5.png";
import i10 from "./Logo8.png";
import portfolio from "./portfolio.png"
import girl from "./girl.png"
import avatar from "./Avatar.png"
import globe from "../SVGs/globe.svg"; 
import globe2 from "../SVGs/globe2.svg"; 
import phone from "../SVGs/mobile.svg"; 
import code from "../SVGs/code.svg";
import chat from "../SVGs/chat.svg";
import adeel from "../Images/adeel.png";
import raza from "../Images/raza.png";
import saad from "../Images/saad.png";
import talha from "../Images/talha.png";
import haroon from "../Images/haroon.png";
import abdurman from "../Images/abdurman.png";


const images = {
  logo,i1,i2,i3,i4,i5,i6,i7,i8,i9,i10,portfolio,girl,avatar,globe,globe2,phone,code,chat,adeel,raza,saad,talha,haroon,abdurman
};
export default images;